import React from "react";
import "../styles/LoaderOverlay.css";

import PropTypes from "prop-types";


const LoaderOverlay = ({ visible, label = "Cargando...", fullscreen = false, background = null, spinnerColor = null, labelColor = null }) => {
  if (!visible) return null;
  const overlayStyle = background ? { background } : undefined;
  return (
    <div
      className={`loader-overlay${fullscreen ? ' loader-overlay-fullscreen' : ' loader-overlay-absolute'}`}
      style={overlayStyle}
    >
      <div className="loader-overlay-content">
        <div className="loader-overlay-spinner">
          <img
            src="/lux_black.svg"
            alt="Loader"
            className="loader-img-animated"
            aria-label={label}
            style={spinnerColor ? { filter: spinnerColor === '#000' ? '' : `invert(1) brightness(2)` } : {}}
          />
        </div>
        {label && (
          <div className="loader-label" style={labelColor ? { color: labelColor } : {}}>
            {label}
          </div>
        )}
      </div>
    </div>
  );
};

LoaderOverlay.propTypes = {
  visible: PropTypes.bool.isRequired,
  label: PropTypes.string,
  fullscreen: PropTypes.bool,
  background: PropTypes.string,
  spinnerColor: PropTypes.string,
  labelColor: PropTypes.string,
};

export default LoaderOverlay;
